import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { api, defaultWindow, toIso, when } from './api';
const STATUS = [['pending', 'Waiting for review'], ['approved', 'Approved'], ['published', 'Published'], ['failed', 'Failed'], ['rejected', 'Rejected'], ['all', 'All']];
const KIND = {
  discussion: 'New discussion',
  reply: 'Reply',
  poll: 'Poll'
};

/**
 * Drafts: generate with AI or write by hand, edit, approve, publish. Nothing AI-written goes out without
 * approval, and changing an approved draft's text sends it back for review. attrs: state
 */
export default class DraftsTab extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.status = 'pending';
    this.account = '';
    this.drafts = null;
    this.counts = {};
    this.busy = {};
    this.edits = {};
    this.newForm = null;
    this.load();
  }
  load() {
    const q = '?status=' + this.status + (this.account ? '&account=' + this.account : '');
    return api('GET', '/drafts' + q).then(r => {
      this.drafts = r.drafts || [];
      this.counts = r.counts || {};
      this.attrs.state.draftCounts = this.counts;
    }).catch(() => this.drafts = []).finally(() => m.redraw());
  }
  run(key, p) {
    this.busy[key] = true;
    m.redraw();
    return p.catch(() => {}).finally(() => {
      this.busy[key] = false;
      m.redraw();
    });
  }
  accountName(id) {
    const a = (this.attrs.state.accounts || []).find(x => x.userId === id);
    return a ? a.displayName : '#' + id;
  }
  view() {
    const accounts = (this.attrs.state.accounts || []).filter(a => a.status === 'active');
    return m("div", {
      className: "VEC-drafts"
    }, m("div", {
      className: "VEC-row-head"
    }, m("div", {
      className: "VEC-filters"
    }, STATUS.map(_ref => {
      let [k, l] = _ref;
      return m(Button, {
        className: 'Button Button--text' + (this.status === k ? ' is-active' : ''),
        onclick: () => {
          this.status = k;
          this.drafts = null;
          this.load();
        }
      }, l, k !== 'all' && this.counts[k] ? ' (' + this.counts[k] + ')' : '');
    })), m("div", {
      className: "VEC-actions"
    }, m("select", {
      className: "FormControl VEC-inline-select",
      value: this.account,
      onchange: e => {
        this.account = e.target.value;
        this.drafts = null;
        this.load();
      }
    }, m("option", {
      value: ""
    }, "All accounts"), (this.attrs.state.accounts || []).map(a => m("option", {
      value: a.userId
    }, a.displayName))), m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-plus",
      onclick: () => this.newForm = this.newForm ? null : {
        account: accounts[0] ? accounts[0].userId : '',
        kind: 'discussion',
        topic: '',
        tags: [],
        discussion: '',
        replyTo: '',
        instructions: ''
      }
    }, "New draft"))), this.newForm ? this.newDraftForm(accounts) : null, !this.drafts ? m(LoadingIndicator, null) : this.drafts.length ? this.drafts.map(d => this.card(d)) : m("p", {
      className: "VEC-empty"
    }, "No drafts here."));
  }
  newDraftForm(accounts) {
    const f = this.newForm;
    const tags = (app.store.all('tags') || []).filter(t => !(t.isHidden && t.isHidden())).sort((a, b) => a.name().localeCompare(b.name()));
    return m("div", {
      className: "VEC-card"
    }, m("h3", null, "New draft"), m("div", {
      className: "VEC-fields"
    }, m("label", {
      className: "VEC-field"
    }, m("span", null, "Account"), m("select", {
      className: "FormControl",
      value: f.account,
      onchange: e => f.account = parseInt(e.target.value, 10)
    }, accounts.map(a => m("option", {
      value: a.userId
    }, a.displayName)))), m("label", {
      className: "VEC-field"
    }, m("span", null, "Type"), m("select", {
      className: "FormControl",
      value: f.kind,
      onchange: e => f.kind = e.target.value
    }, Object.keys(KIND).map(k => m("option", {
      value: k
    }, KIND[k])))), m("span", {
      className: "VEC-field is-spacer"
    }), f.kind === 'reply' ? [m("label", {
      className: "VEC-field is-wide"
    }, m("span", null, "Discussion"), m("input", {
      className: "FormControl",
      value: f.discussion,
      placeholder: "Paste the discussion link",
      oninput: e => f.discussion = e.target.value
    })), m("label", {
      className: "VEC-field"
    }, m("span", null, "Reply to post #"), m("input", {
      className: "FormControl",
      type: "number",
      min: "1",
      value: f.replyTo,
      placeholder: "optional",
      oninput: e => f.replyTo = e.target.value
    }))] : [m("label", {
      className: "VEC-field is-wide"
    }, m("span", null, "Topic"), m("input", {
      className: "FormControl",
      value: f.topic,
      placeholder: "What should it be about? e.g. first-time buyer programmes in Ontario",
      oninput: e => f.topic = e.target.value
    })), m("div", {
      className: "VEC-field is-wide"
    }, m("span", null, "Tags"), m("div", {
      className: "VEC-tags"
    }, tags.map(t => {
      const on = f.tags.includes(t.id());
      return m("button", {
        type: "button",
        className: 'VEC-tag' + (on ? ' is-on' : ''),
        onclick: () => f.tags = on ? f.tags.filter(x => x !== t.id()) : [...f.tags, t.id()]
      }, t.name());
    })))], m("label", {
      className: "VEC-field is-wide"
    }, m("span", null, "Instructions for the AI (optional)"), m("input", {
      className: "FormControl",
      value: f.instructions,
      placeholder: "e.g. ask for experiences with specific lenders; keep it short",
      oninput: e => f.instructions = e.target.value
    }))), m("div", {
      className: "VEC-actions"
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-magic",
      loading: this.busy.generate,
      disabled: !this.attrs.state.aiReady,
      onclick: () => this.create(true)
    }, "Write with AI"), m(Button, {
      className: "Button",
      loading: this.busy.blank,
      onclick: () => this.create(false)
    }, "Start blank (write it myself)"), m(Button, {
      className: "Button",
      onclick: () => this.newForm = null
    }, "Cancel")));
  }
  create(generate) {
    const f = this.newForm;
    const body = {
      account: f.account,
      kind: f.kind,
      generate,
      topic: f.topic,
      tags: f.tags,
      discussion: f.discussion,
      replyTo: f.replyTo || null,
      instructions: f.instructions,
      title: generate ? '' : f.topic
    };
    this.run(generate ? 'generate' : 'blank', api('POST', '/drafts', body).then(() => {
      this.newForm = null;
      this.status = 'pending';
      return this.load();
    }));
  }
  card(d) {
    const e = this.edits[d.id] = this.edits[d.id] || {
      title: d.title || '',
      content: d.content || '',
      question: d.poll ? d.poll.question : '',
      options: d.poll ? d.poll.options.join('\n') : '',
      instructions: d.instructions || ''
    };
    const editable = d.status !== 'published';
    const changed = e.title !== (d.title || '') || e.content !== (d.content || '') || d.poll && (e.question !== d.poll.question || e.options !== d.poll.options.join('\n'));
    const busy = k => this.busy[k + d.id];
    const target = d.kind === 'reply' ? m("a", {
      href: '/d/' + d.discussionId + (d.replyToNumber ? '/' + d.replyToNumber : ''),
      target: "_blank",
      rel: "noopener"
    }, d.discussionTitle || 'Discussion #' + d.discussionId, d.replyToNumber ? ' · reply to #' + d.replyToNumber : '') : null;
    return m("div", {
      className: 'VEC-card VEC-draft is-' + d.status,
      key: d.id
    }, m("div", {
      className: "VEC-draft-head"
    }, m("strong", null, this.accountName(d.accountId)), m("span", {
      className: "VEC-pill"
    }, KIND[d.kind]), m("span", {
      className: 'VEC-pill is-' + d.status
    }, (STATUS.find(s => s[0] === d.status) || [0, d.status])[1]), d.aiGenerated ? m("span", {
      className: "VEC-pill"
    }, m("i", {
      className: "fas fa-magic"
    }), " AI") : null, target, m("span", {
      className: "VEC-muted VEC-draft-time"
    }, String(d.updatedAt).slice(0, 16))), d.error ? m("div", {
      className: "VEC-flag"
    }, m("i", {
      className: "fas fa-exclamation-circle"
    }), " ", d.error) : null, d.kind !== 'reply' ? m("input", {
      className: "FormControl VEC-draft-title",
      value: e.title,
      disabled: !editable,
      placeholder: "Title",
      oninput: ev => e.title = ev.target.value
    }) : null, m("textarea", {
      className: "FormControl VEC-content",
      rows: d.kind === 'reply' ? 5 : 8,
      value: e.content,
      disabled: !editable,
      oninput: ev => e.content = ev.target.value
    }), d.kind === 'poll' ? m("div", {
      className: "VEC-fields"
    }, m("label", {
      className: "VEC-field is-wide"
    }, m("span", null, "Poll question"), m("input", {
      className: "FormControl",
      value: e.question,
      disabled: !editable,
      oninput: ev => e.question = ev.target.value
    })), m("label", {
      className: "VEC-field is-wide"
    }, m("span", null, "Options (one per line)"), m("textarea", {
      className: "FormControl",
      rows: "4",
      value: e.options,
      disabled: !editable,
      oninput: ev => e.options = ev.target.value
    }))) : null, d.status === 'published' ? m("p", {
      className: "VEC-help"
    }, m("a", {
      href: '/d/' + d.publishedDiscussionId + (d.publishedPostId ? '' : ''),
      target: "_blank",
      rel: "noopener"
    }, m("i", {
      className: "fas fa-check"
    }), " Published ", String(d.publishedAt).slice(0, 16), ": open it"), " \xB7 approved by ", d.approvedBy || '—') : m("div", {
      className: "VEC-actions"
    }, changed ? m(Button, {
      className: "Button Button--primary",
      loading: busy('save'),
      onclick: () => this.save(d, e)
    }, "Save changes", d.status === 'approved' ? ' (needs re-approval)' : '') : null, !changed && (d.status === 'pending' || d.status === 'failed') ? m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-check",
      loading: busy('approve'),
      onclick: () => this.act(d, 'approve')
    }, "Approve") : null, !changed && d.status === 'approved' ? m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-paper-plane",
      loading: busy('publish'),
      onclick: () => this.act(d, 'publish')
    }, "Publish now") : null, d.status !== 'rejected' ? m(Button, {
      className: "Button",
      loading: busy('reject'),
      onclick: () => this.act(d, 'reject')
    }, "Reject") : null, m("input", {
      className: "FormControl VEC-regen-input",
      value: e.instructions,
      placeholder: "Ask for changes, e.g. shorter, add a question",
      oninput: ev => e.instructions = ev.target.value
    }), m(Button, {
      className: "Button",
      icon: "fas fa-redo",
      loading: busy('regenerate'),
      disabled: !this.attrs.state.aiReady,
      onclick: () => this.act(d, 'regenerate', {
        instructions: e.instructions
      })
    }, "Rewrite with AI"), m(Button, {
      className: "Button Button--text",
      onclick: () => this.remove(d)
    }, "Delete")), d.status === 'approved' ? this.scheduleRow(d) : null);
  }
  scheduleRow(d) {
    const sc = d.schedule;
    if (sc && ['queued', 'running', 'paused'].includes(sc.status)) {
      return m("p", {
        className: "VEC-help"
      }, m("i", {
        className: "fas fa-clock"
      }), " Scheduled for ", when(sc.runAt), sc.status === 'paused' ? ' (paused)' : '', ". Manage it in Scheduler.");
    }
    const w = (this.windows = this.windows || {})[d.id] || (this.windows[d.id] = defaultWindow(24));
    return m("div", {
      className: "VEC-schedule-row"
    }, m("span", {
      className: "VEC-muted"
    }, "Approved by ", d.approvedBy, ". Or schedule between"), m("input", {
      type: "datetime-local",
      className: "FormControl",
      value: w.earliest,
      oninput: e => w.earliest = e.target.value
    }), m("span", {
      className: "VEC-muted"
    }, "and"), m("input", {
      type: "datetime-local",
      className: "FormControl",
      value: w.latest,
      oninput: e => w.latest = e.target.value
    }), m(Button, {
      className: "Button",
      icon: "fas fa-clock",
      loading: this.busy['schedule' + d.id],
      onclick: () => this.act(d, 'schedule', {
        earliest: toIso(w.earliest),
        latest: toIso(w.latest)
      })
    }, "Schedule"), sc && sc.error ? m("span", {
      className: "VEC-flag"
    }, "Last schedule: ", sc.status, " \u2014 ", sc.error) : null, m("p", {
      className: "VEC-help VEC-pastnote"
    }, "A time in the past publishes on the next run, dated to that time."));
  }
  save(d, e) {
    const body = {
      title: e.title,
      content: e.content
    };
    if (d.kind === 'poll') body.poll = {
      question: e.question,
      options: e.options.split('\n')
    };
    this.run('save' + d.id, api('POST', '/drafts/' + d.id, body).then(r => this.replace(r.draft)));
  }
  act(d, action, body) {
    this.run(action + d.id, api('POST', '/drafts/' + d.id + '/' + action, body || {}).then(r => {
      if (action === 'publish') app.alerts.show({
        type: 'success'
      }, 'Published as ' + this.accountName(d.accountId) + '.');
      if (action === 'schedule' && r.draft && r.draft.schedule) app.alerts.show({
        type: 'success'
      }, 'Scheduled for ' + when(r.draft.schedule.runAt) + '.');
      this.replace(r.draft);
      if (action !== 'regenerate') return this.load();
    }));
  }
  replace(draft) {
    if (!draft) return;
    delete this.edits[draft.id];
    this.drafts = this.drafts.map(x => x.id === draft.id ? draft : x);
  }
  remove(d) {
    if (!window.confirm('Delete this draft?')) return;
    this.run('delete' + d.id, api('DELETE', '/drafts/' + d.id).then(() => this.load()));
  }
}